module.exports = __webpack_public_path__ + "catalog/items/firesafety/Running-Man-Symbol/Running-Man-Symbol.svg";